// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V8AG","rootMobile":"styles_rootMobile__1v2yM"};